<template>
  <div class="description" :class="{'description_animating': pageReady && isActive}" v-html="descrValue" />
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'pageTitle',
    props: ['descrValue', 'isActive'],
    computed: mapGetters({
      pageReady: 'pageReady',
    }),
  };
</script>

<style scoped>
  .description {
    opacity: 0;
    position: relative;
    left: -50px;
    max-width: 400px;
    margin-left: 100px;

    &.description_animating {
      left: 0;
      opacity: 1;
      transform: translate3d(0, 0, 0);
      transition: all 1s cubic-bezier(0.500, 0.000, 0.100, 1.000) 0.9s;
    }

    &.static {
      left: 0;
      opacity: 1;
    }
  }

  @media (max-width: 850px) {
    .description {
      max-width: none;
      margin-left: 0;
      line-height: 160%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Description.vue?1ff51b07